import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule, SharedModule } from '../../shared';
import { CoreModule } from '../../core/core.module';

import { ModalComponent } from '../../shared/modal/modal.component';
import { CommonModule } from '@angular/common';
import { FlorderModule } from 'app/modules/florder/florder.module';
import { CCRRoutingModule } from './ccr-routing.module';
import { CCREditDeliveryComponent } from './ccr-edit-delivery/ccr-edit-delivery.component';
import { CCREditDetailComponent } from './ccr-edit-detail/ccr-edit-detail.component';
import { CCREditPlanningComponent } from './ccr-edit-planning/ccr-edit-planning.component';
import { CCREditContainer } from './ccr-edit-container/ccr-edit.container';
import { CCREditMaterialComponent } from './ccr-edit-material/ccr-edit-material.component';
import { CCRMaterialLinesComponent } from './ccr-material-lines/ccr-material-lines.component';

@NgModule({
  imports: [CommonModule, FlorderModule, CCRRoutingModule, AngularMaterialModule, SharedModule, CoreModule, ReactiveFormsModule],
  declarations: [CCREditDeliveryComponent, CCREditDetailComponent, CCREditPlanningComponent, CCREditMaterialComponent, CCRMaterialLinesComponent, CCREditContainer],
})
export class CCRModule {}
